module.exports = __webpack_public_path__ + "static/media/header-user.e6fe5771.svg";


//////////////////
// WEBPACK FOOTER
// ./src/presentation/assets/img/header-user.svg
// module id = 527
// module chunks = 0